<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <!-- <h4 class="color-secundary">Base garantizados</h4> -->
      <p class="mb-5 text-justify">
        <!-- <b>Icono circular:</b> a través de esta opcíón, se puede descargar la base de garantizados al último corte contable.
        <br />-->
        <b>Filtro:</b> a través de esta opcíón, se puede descargar la base de
        operaciones con productos FGA Fondo de Garantías, en un periodo de
        tiempo determinado.
      </p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="TablaGarantizado.datos"
        @click-generar="generar"
        @click-buscar="loadData"
        @click-event="clickEvent"
        filtro
        :showExportToExcel="false"
        :showFilterDates="true"
        :showButtonBuscar="true"
        :showButtonBorrar="false"
        :showButtonGenerar="true"
        :showButtonGenerarHistorico="false"
        :showFilterEstadoGarantia="true"
        :EstadoGarantia="EstadoGarantia"
        :Modelos="Modelos"
        :TipoArchivo="TipoArchivo"
        :showFilterModelos="true"
        :showFilterTipoDoc="true"
        :showFilterConvenios="true"
        :Convenios="convenios"
        :checkEstado="checkEstado"
        :loadGenerar="loadGenerar"
        :checkedModalBase="true"
      >
        <table-column
          slot="label"
          :label="'Archivo'"
          v-bind:value="'nombre'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Usuario'"
          v-bind:value="'usuario'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha de creación'"
          v-bind:value="'created_at'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'estado'"
          :customClass="'text-center'"
        ></table-column>
        <table-column slot="label" :label="'Descargar archivo'" :icon="'fa'">
          <template
            slot="icon"
            :icon="'fa fa-download'"
            :class="'btn btn-sm btn-info'"
            :slug="'Descargar'"
            :tooltip="'Descargar archivo'"
            :customActive="buttonsActives"
            :loading="false"
          ></template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import FileSaver from "file-saver";
//import FileSaver from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      fecha_inicio: this.$moment().startOf("month").format("YYYY-MM-DD"),
      fecha_fin: this.$moment().format("YYYY-MM-DD"),
      checkEstado: true,
      loadGenerar: false,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      EstadoGarantia: [
        { value: null, text: "Estado", disabled: true },
        { value: "VIGENTE", text: "Vigente" },
        { value: "CANCELADA", text: "Cancelada" },
        { value: "EXTINGUIDA", text: "Extinguida" },
        { value: "PAGADA", text: "Pagada" },
      ],
      Modelos: [
        { value: null, text: "Modelo", disabled: true },
        { value: 1, text: "Respaldo FGA" },
        { value: 2, text: "Cobertura Integral" },
      ],
      TipoArchivo: [{ value: null, text: "CSV", disabled: true }],
      estadoGarantiaSelected: null,
      modelo: null,
      convenio: null,
      buttonsActives: ["finalizado", "rechazado", "pendiente de revision"],
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaGarantizado: "pages/tablaGarantizado",
      TablaVerProducto: "pages/TablaVerProducto",
      reloaded: "pages/reload",
      loading: "loading",
      user: "user/user",
      echo: "echo",
      api: "api",
    }),
    convenios() {
      let data = this.$store.getters["pages/convenios"].map((convenio) => {
        return { value: convenio.id, text: convenio.nombre_convenio };
      });
      data.unshift({ value: null, text: "Código", disabled: true });
      return data;
    },
    dataLength() {
      return this.$store.getters["pages/dataInformes"].paginacion.total;
    },
    data() {
      return this.$store.getters["pages/dataInformes"].datos;
    },
    total() {
      return this.$store.getters["pages/total"];
    },
    saveToExcel() {},
    routeName() {
      return this.$router.currentRoute.name;
    },
    archivoTemporal() {
      return this.$store.getters["pages/datosGarantizadoTemporal"];
    },
  },
  methods: {
    generar(event) {
      this.$store.commit("SET_LOADING", true);
      this.loadGenerar = true;
      this.$toasted.show("Generando archivo, por favor espere", {
        theme: "toasted-primary",
        position: "top-right",
        duration: 10000,
      });

      if (!event.filterTipoArchivoSelected) {
        event.filterTipoArchivoSelected = "csv";
      }

      this.api
        .post("informes/base_garantizado2", {
          fecha_inicio: event.fecha_inicio,
          fecha_fin: event.fecha_fin,
          estado_garantia: event.filterEstadoGarantiaSelected,
          extension: event.filterTipoArchivoSelected,
          modelo: event.filterModelosSelected,
          convenio: event.convenio,
        })
        .then(() => {
          this.loadGenerar = false;
          this.loadData();
        });

      this.fecha_inicio = event.fecha_inicio;
      this.fecha_fin = event.fecha_fin;
      this.convenio = event.convenio;
      this.estadoGarantiaSelected = event.filterEstadoGarantiaSelected;
      this.modelo = event.filterModelosSelected;
    },
    generarCompleto(event) {
      this.$store.commit("SET_LOADING", true);
      this.loadGenerar = true;
      this.$toasted.show("Generando archivo, por favor espere", {
        theme: "toasted-primary",
        position: "top-right",
        duration: 10000,
      });

      let data = new Promise((res, rej) => {
        this.$store.getters.api
          .post(
            "informes/base_garantizado2/temporal",
            {
              convenio: event.convenio
                ? event.convenio
                : this.convenios[1].value,
            },
            { responseType: "arraybuffer" }
          )
          .then((response) => {
            res(response);
          })
          .catch((error) => {
            rej(error);
          });
      })
        .then((response) => {
          FileSaver.saveAs(
            new Blob([response.data]),
            "base_garantizados" +
              Math.floor(Math.random() * 99999999999) +
              ".txt"
          );
          this.loadGenerar = false;
          this.$store.commit("SET_LOADING", false);
        })
        .catch((err) => {
          let toast = this.$toasted.show(
            "Error intentando descargar el archivo: " + err.message,
            {
              theme: "toasted-primary",
              position: "bottom-right",
              duration: 5001,
            }
          );
          this.loadGenerar = false;
          this.$store.commit("SET_LOADING", false);
        });

      /*this.$toasted.show(
        "Generando archivo, por favor espere",
        {
          theme: "toasted-primary",
          position: "top-right",
          duration: 10000,
        }
      )

      if (!event.filterTipoArchivoSelected) {
        event.filterTipoArchivoSelected = 'csv'
      }

      this.api.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('tokenSig')}`
      this.api.post("portal/informes/base_garantizados", {
        "fecha_inicio": event.fecha_inicio,
        "fecha_fin": event.fecha_fin,
        "estado_garantia": event.filterEstadoGarantiaSelected,
        "extension": event.filterTipoArchivoSelected,
        "modelo": event.filterModelosSelected,
        "modelo": event.convenio,
      }).then(() => {
        this.loadGenerar = false
      })*/

      /*this.fecha_inicio = event.fecha_inicio;
      this.fecha_fin = event.fecha_fin;
      this.convenio = event.convenio;
      this.estadoGarantiaSelected = event.filterEstadoGarantiaSelected;
      this.modelo = event.filterModelosSelected;
      this.loadData();*/
    },
    async clickEvent(data, slug) {
      switch (slug) {
        case "Descargar":
          this.$toasted.show(
            "Por favor espere mientras descargamos el archivo",
            {
              theme: "toasted-primary",
              position: "top-center",
              duration: 3000,
            }
          );

          this.$store.commit("SET_LOADING", true);

          let descarga = new Promise((res, rej) => {
            this.api
              .post("/informes/base_garantizado2/descargar", {
                id: data.id,
              })
              .then((response) => {
                res(response.data);
              })
              .catch((error) => {
                rej(error);
              });
          });

          descarga
            .then((datos) => {
              // saveAs(new Blob([datos]), data.nombre);
              window.location.href = `${datos}`;
            })
            .catch(() => {
              let toast = this.$toasted.show(
                "Error intentando descargar el archivo",
                {
                  theme: "toasted-primary",
                  position: "bottom-right",
                  duration: 5001,
                }
              );
            })
            .then(() => {
              this.$store.commit("SET_LOADING", false);
            });

          break;
      }
    },
    loadData() {
      this.$store.dispatch("pages/fetchGarantizado", {
        endpoint: "informes/base_garantizado2",
      });
    },
  },
  mounted() {
    if (!localStorage.reload_garantizados) {
      location.reload();
      localStorage.reload_garantizados = 1;
    }
    this.loadData();
    this.$store.dispatch("pages/fetchConvenios", {
      endpoint: "informes/convenio",
    });
  },
};
</script>
